import { Service } from '@angular/core';

export type ServerError = { field: string; message: string };

@Service()
export class FormValidationService {
  validateErrors = (errors?: ServerError[]) =>
    errors?.reduce<{ [key: string]: string | undefined }>((errorMap, error) => {
      errorMap[error.field] = error.message;

      return errorMap;
    }, {}) || {};

  validateField = (errors: ServerError[], key: string) =>
    Object.entries(this.validateErrors(errors)).find(
      ([field]) => field === key
    )?.[1];
}
